import BootstrapTable from 'react-bootstrap-table-next';
import { PaginationFooter } from '../../Table/PaginationFooter';
import { managerUserDeleteFormatter } from '../helper';
import { useEffect, useMemo, useRef, useState } from 'react';
import editPenOutlineIcon from '../../../../assets/img/button-icons/edit-pen-outline.svg';
import editPenSolidIcon from '../../../../assets/img/button-icons/edit-pen-solid.svg';
import plusCircleIcon from '../../../../assets/img/button-icons/plus-circle-white.svg';
import './style.css';
import { useSelector } from 'react-redux';
import { useGetAllCatalogOrderSets, useUpdateCatalogOrderSet } from './hooks';
import { usePagination } from '../../Table/PaginationFooter/hooks/usePagination';
import ConfirmationModal from '../../Modal/ConfirmationModal/ConfirmationModal';
import { mapToOrderSetMedicationDetails } from '../OrderSetForm/helper';
import { SystemPermission } from '../../../../context';
import { OrderSetForm } from '../OrderSetForm/OrderSetForm';
import { useToastMessage } from '../../../hooks/useToastMessage';
import { Toast } from 'react-bootstrap';

const columns = [
  {
    dataField: 'orderSetName',
    text: '',
    classes: 'col18 text-bold order-header',
    headerClasses: 'user-normal-header',
  },
];

const expandRow = {
  className: 'expanding-foo',
  renderer: (row) => (
    <div style={{ backgroundColor: '#e2e8e9', padding: '0.5rem 0.5rem' }}>
      <OrderSetForm
        orderSetData={row}
        onCancel={() => {
          document.getElementById(`edit-order-set-${row.id}`).click();
        }}
        onCancelAndRerender={() => {
          document.getElementById(`edit-order-set-${row.id}`).click();
          setTimeout(() => {
            document.getElementById('order-set-force-render-button').click();
          }, 1000);
        }}
      />
    </div>
  ),
  showExpandColumn: true,
  expandByColumnOnly: true,
  // only support 'left' or 'right'
  expandColumnPosition: 'right',
  expandHeaderColumnRenderer: ({ isAnyExpands }) => {
    return null;
  },
  expandColumnRenderer: ({ expanded, rowKey }) => {
    return (
      <>
        <button id={`edit-order-set-${rowKey}`} className="medication-button">
          {expanded ? (
            <img src={editPenSolidIcon} className="icon" alt="edit pen icon" />
          ) : (
            <img
              src={editPenOutlineIcon}
              className="icon"
              alt="edit pen icon"
            />
          )}
        </button>
      </>
    );
  },
};
export const MedicationOrderSets = () => {
  const [forceRender, setForceRender] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const activeId = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showNewMedForm, setShowNewMedForm] = useState(false);
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);
  const { postGetAllCatalogOrderSets, orderSetData } =
    useGetAllCatalogOrderSets();

  const { postUpdateCatalogOrderSet, errorMessage } =
    useUpdateCatalogOrderSet();
  const { closeToast, showToast, setToast, toastMessage } = useToastMessage();

  const canEditMedicationProfile =
    selectedTenancy?.userPermissions?.[
      SystemPermission.EDIT_MEDICATION_PROFILE
    ] || false;

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target && e.target.getAttribute('id')) {
        setActiveIndex(rowIndex);
        setShowConfirmModal(true);
        activeId.current = row.id;
      }
    },
  };

  const columnsWithAction = useMemo(() => {
    if (canEditMedicationProfile) {
      return [
        ...columns,
        {
          dataField: 'id',
          text: '',
          classes: 'col3 text-center',
          formatter: managerUserDeleteFormatter,
          headerClasses: 'user-normal-header',
          renderer: (row) => (
            <div
              style={{ backgroundColor: '#e2e8e9', padding: '0.5rem 0.5rem' }}
            >
              <OrderSetForm
                setToast={setToast}
                orderSetData={row}
                onCancel={() => {
                  document.getElementById(`edit-order-set-${row.id}`).click();
                }}
                onCancelAndRerender={() => {
                  document.getElementById(`edit-order-set-${row.id}`).click();
                  setTimeout(() => {
                    document
                      .getElementById('order-set-force-render-button')
                      .click();
                  }, 1000);
                }}
              />
            </div>
          ),
        },
      ];
    }

    return columns;
  }, [canEditMedicationProfile]);

  useEffect(() => {
    postGetAllCatalogOrderSets({ tenancyId: selectedTenancy.tenancy_id });
  }, [forceRender]);

  useEffect(() => {
    if (errorMessage) setToast(errorMessage);
  }, [errorMessage]);
  const {
    currentPage,
    totalPages,
    pageSize,
    handleNextPage,
    handlePreviousPage,
    setPageSize,
    canNextPage,
    canPreviousPage,
  } = usePagination({
    defaultSize: 10,
    totalCount: Array.isArray(orderSetData) ? orderSetData.length : 0,
  });
  const paginatedData = (Array.isArray(orderSetData) ? orderSetData : []).slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );
  const sort = { dataField: 'id', order: 'asc' };
  const onDeleteOrderSet = async (activeIndex) => {
    const itemToDelete = paginatedData[activeIndex];
    const payload = {
      orderSetId: itemToDelete.id,
      orderSetName: itemToDelete.orderSetName,
      isActive: !!itemToDelete.isActive,
      isDeleted: true,
      note: itemToDelete.note || '',
      medications: Array.isArray(itemToDelete.medications)
        ? itemToDelete.medications.map((item) =>
            mapToOrderSetMedicationDetails(item),
          )
        : [],
    };
    setShowConfirmModal(false);
    await postUpdateCatalogOrderSet(payload);
    setForceRender((count) => {
      return count + 1;
    });
  };

  return (
    <>
      <div className="medication-med-catalogue-container">
        <div className="table-actions">
          {canEditMedicationProfile ? (
            <button
              className="btn btnPrimary"
              style={{ minWidth: 110 }}
              type="button"
              onClick={() => setShowNewMedForm(true)}
            >
              Add new order set
              <img
                style={{ marginLeft: '5px' }}
                src={plusCircleIcon}
                alt="add new order icon"
              />
            </button>
          ) : null}
        </div>
        {showNewMedForm ? (
          <OrderSetForm
            onCancel={() => {
              setShowNewMedForm(false);
            }}
            onCancelAndRerender={() => {
              setShowNewMedForm(false);
              setForceRender((count) => count + 1);
            }}
            setToast={setToast}
          />
        ) : null}
        <div style={{ position: 'relative' }}>
          <BootstrapTable
            bootstrap4
            keyField="id"
            wrapperClasses="table-responsive"
            id="manage-order-set-table"
            remote={{ pagination: true, filter: false, sort: true }}
            bordered={false}
            data={paginatedData}
            columns={columnsWithAction}
            rowEvents={rowEvents}
            // rowClasses={rowClasses}
            sort={sort}
            expandRow={canEditMedicationProfile ? expandRow : []}
            // onTableChange={handleTableChange}
          />
          <PaginationFooter
            currentPage={currentPage}
            totalPage={totalPages}
            pageSize={pageSize}
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            setPageSize={setPageSize}
          />
          {showConfirmModal && (
            <ConfirmationModal
              onCancel={() => {
                setShowConfirmModal(false);
              }}
              onConfirm={() => {
                onDeleteOrderSet(activeIndex);
              }}
              top={`${(activeIndex + 1) * 50}px`}
              right={'-50px'}
            />
          )}
        </div>
      </div>
      <button
        style={{ display: 'none' }}
        id="order-set-force-render-button"
        onClick={() => {
          setForceRender((count) => count + 1);
        }}
      >
        force render button
      </button>
      <Toast show={showToast} onClose={closeToast} className="team-toast">
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
    </>
  );
};
